import { oc } from "@orpc/contract";
import { z } from "zod";
import { GetFieldSchemaResponseSchema } from "./e844sd-field-schema.contract";

export const e849FieldSchemaContracts = {
  getSchema: oc
    .input(z.object({}))
    .output(GetFieldSchemaResponseSchema)
    .route({ method: "GET" }),
} as const;
